/**
 * @fileoverview GET handler for the "/apps/:app_group_id/charts/whatsapp" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { appsAppGroupIdChartsWhatsapp } from "./constants";
import type { AppsAppGroupIdChartsWhatsappResult } from "./types";

export const getAppsAppGroupIdChartsWhatsapp = reactQueryFetcherAdapter(
  appsAppGroupIdChartsWhatsapp,
  (
    signal: AbortSignal,
    appGroupId: string,
    startDate: number,
    endDate: number
  ): Promise<AppsAppGroupIdChartsWhatsappResult> => {
    return fetch(
      `/apps/${appGroupId}/charts/whatsapp`,
      "GET",
      {
        start_date: startDate,
        end_date: endDate,
      },
      { signal }
    );
  }
);
